import { Link } from "gatsby";
import React from "react";
import Button from "../atoms/button";
import Wand from '../../assets/images/svg/wand_2.svg';

import {
    buttonIcon,
    buttonLink,
    buttonNew,
} from './button-icon.module.scss';


interface IButtonIconProps {
    className?: '',
    text?: string,
    htmlType?: 'button' | 'submit' | 'reset',
    withLink?: boolean,
    link?: string,
    icon?: string,
    onClick?: () => void;
}

const ButtonIcon: React.FC<IButtonIconProps> = ({
    className = '',
    text = '',
    htmlType = 'button',
    withLink = true,
    link = '',
    icon = '',
    onClick
}) => {
    return (
        <div className={`${className} ${buttonIcon}`}>
            {withLink && <Link className={buttonLink} to={link}>
                <Button htmlType={htmlType} className={buttonNew} color="primary" type="filled">
                    {icon && <div className={buttonIcon}>{icon}</div>}
                    <>{text}</>
                </Button>
            </Link>}
            {!withLink && <Button htmlType={htmlType} onClick={onClick} className={buttonNew} color="primary" type="filled">
                    {icon &&<div className={buttonIcon}>{icon}</div>}
                    <>{text}</>
                </Button>}

        </div>
    );
};


export default ButtonIcon;